import { CoreGraphNode } from "../../core/graph/CoreGraphNode";
import { UIData } from "./utils/UIData";
import { FlagsControllerD } from "./utils/FlagsController";
import { NodeStatesController } from "./utils/StatesController";
import { HierarchyParentController } from "./utils/hierarchy/ParentController";
import { HierarchyChildrenController } from "./utils/hierarchy/ChildrenController";
import { NodeLifeCycleController } from "./utils/LifeCycleController";
import { TypedContainerController } from "./utils/ContainerController";
import { NodeCookController } from "./utils/CookController";
import { NameController } from "./utils/NameController";
import { NodeSerializer } from "./utils/Serializer";
import { ParamsController } from "./utils/params/ParamsController";
import { ParamsValueAccessor } from "./utils/params/ParamsValueAccessor";
import { IOController } from "./utils/io/IOController";
import { ParamsAccessor } from "./utils/params/ParamsAccessor";
export class TypedNode extends CoreGraphNode {
  constructor(scene, nodeName = "BaseNode", createOptions) {
    super(scene, nodeName);
    this.createOptions = createOptions;
    this.containerController = new TypedContainerController(this);
    this.pv = new ParamsValueAccessor();
    this.p = new ParamsAccessor();
    this._initialized = false;
  }
  copy_param_values(node) {
    const non_spare = this.params.non_spare;
    for (let param of non_spare) {
      const other_param = node.params.get(param.name());
      if (other_param) {
        param.copyValue(other_param);
      }
    }
  }
  get parentController() {
    return this._parent_controller = this._parent_controller || new HierarchyParentController(this);
  }
  static displayedInputNames() {
    return [];
  }
  childrenControllerContext() {
    return this._childrenControllerContext;
  }
  _create_childrenController() {
    if (this._childrenControllerContext) {
      return new HierarchyChildrenController(this, this._childrenControllerContext);
    }
  }
  get childrenController() {
    return this._childrenController = this._childrenController || this._create_childrenController();
  }
  childrenAllowed() {
    return this._childrenControllerContext != null;
  }
  get uiData() {
    return this._uiData = this._uiData || new UIData(this);
  }
  get states() {
    return this._states = this._states || new NodeStatesController(this);
  }
  get lifecycle() {
    return this._lifecycle = this._lifecycle || new NodeLifeCycleController(this);
  }
  get serializer() {
    return this._serializer = this._serializer || new NodeSerializer(this);
  }
  get cookController() {
    return this._cookController = this._cookController || new NodeCookController(this);
  }
  get io() {
    return this._io = this._io || new IOController(this);
  }
  get nameController() {
    return this._nameController = this._nameController || new NameController(this);
  }
  setName(name) {
    this.nameController.setName(name);
  }
  _setCoreName(name) {
    this._name = name;
  }
  get params() {
    return this._paramsController = this._paramsController || new ParamsController(this);
  }
  initializeBaseAndNode() {
    var _a;
    if (!this._initialized) {
      this._initialized = true;
      (_a = this.displayNodeController) == null ? void 0 : _a.initializeNode();
      this.initializeBaseNode();
      this.initializeNode();
      if (this.polyNodeController) {
        this.polyNodeController.initializeNode();
      }
    } else {
      console.warn("node already initialized");
    }
  }
  initializeBaseNode() {
  }
  initializeNode() {
  }
  static type() {
    throw "type to be overriden";
  }
  type() {
    const c = this.constructor;
    return c.type();
  }
  static context() {
    console.error("node has no node_context", this);
    throw "context requires override";
  }
  context() {
    const c = this.constructor;
    return c.context();
  }
  static require_webgl2() {
    return false;
  }
  require_webgl2() {
    const c = this.constructor;
    return c.require_webgl2();
  }
  setParent(parent) {
    this.parentController.setParent(parent);
  }
  parent() {
    return this.parentController.parent();
  }
  firstAncestorWithContext(context) {
    return this.parentController.firstAncestorWithContext(context);
  }
  root() {
    return this._scene.root();
  }
  path(relative_to_parent) {
    return this.parentController.path(relative_to_parent);
  }
  createParams() {
  }
  addParam(type, name, default_value, options) {
    var _a;
    return (_a = this._paramsController) == null ? void 0 : _a.addParam(type, name, default_value, options);
  }
  paramDefaultValue(name) {
    return null;
  }
  cook(input_contents) {
    return null;
  }
  onCookEnd(callbackName, callback) {
    this.cookController.registerOnCookEnd(callbackName, callback);
  }
  async compute() {
    var _a, _b;
    if (this.isDirty() || ((_b = (_a = this.flags) == null ? void 0 : _a.bypass) == null ? void 0 : _b.active())) {
      return await this.containerController.compute();
    } else {
      return this.containerController.container();
    }
  }
  _setContainer(content, message = null) {
    this.containerController.container().set_content(content);
    if (content != null) {
      if (!content.name) {
        content.name = this.path();
      }
      if (!content.node) {
        content.node = this;
      }
    }
    this.cookController.endCook(message);
  }
  createNode(nodeClass, options) {
    var _a;
    return (_a = this.childrenController) == null ? void 0 : _a.createNode(nodeClass, options);
  }
  createOperationContainer(type, operation_container_name, options) {
    var _a;
    return (_a = this.childrenController) == null ? void 0 : _a.createOperationContainer(type, operation_container_name, options);
  }
  removeNode(node) {
    var _a;
    (_a = this.childrenController) == null ? void 0 : _a.removeNode(node);
  }
  dispose() {
    super.dispose();
    this.setParent(null);
    if (this._nameController) {
      this._nameController.dispose();
      this._nameController = void 0;
    }
    if (this._io) {
      this._io.dispose();
      this._io = void 0;
    }
    if (this._lifecycle) {
      this._lifecycle.dispose();
      this._lifecycle = void 0;
    }
    if (this.displayNodeController) {
      this.displayNodeController.dispose();
    }
    if (this._childrenController) {
      this._childrenController.dispose();
      this._childrenController = void 0;
    }
    if (this._paramsController) {
      this._paramsController.dispose();
      this._paramsController = void 0;
    }
    if (this._cookController) {
      this._cookController.dispose();
      this._cookController = void 0;
    }
    if (this._serializer) {
      this._serializer.dispose();
      this._serializer = void 0;
    }
    if (this._uiData) {
      this._uiData.dispose();
      this._uiData = void 0;
    }
  }
  children() {
    var _a;
    return ((_a = this.childrenController) == null ? void 0 : _a.children()) || [];
  }
  node(path) {
    var _a;
    return ((_a = this.parentController) == null ? void 0 : _a.findNode(path)) || null;
  }
  nodeSibling(name) {
    var _a;
    const parent = this.parent();
    if (parent) {
      const node = (_a = parent.childrenController) == null ? void 0 : _a.childByName(name);
      if (node) {
        return node;
      }
    }
    return null;
  }
  nodesByType(type) {
    var _a;
    return ((_a = this.childrenController) == null ? void 0 : _a.nodesByType(type)) || [];
  }
  setInput(inputIndexOrName, node, outputIndexOrName, options) {
    this.io.inputs.setInput(inputIndexOrName, node, outputIndexOrName, options);
  }
  emit(event_name, data = null) {
    this.scene().dispatchController.dispatch(this, event_name, data);
  }
  toJSON(include_param_components = false) {
    return this.serializer.toJSON(include_param_components);
  }
  usedAssembler() {
  }
  integrationData() {
  }
}
export class BaseNodeClass extends TypedNode {
}
export class BaseNodeClassWithDisplayFlag extends TypedNode {
  constructor() {
    super(...arguments);
    this.flags = new FlagsControllerD(this);
  }
}
